;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { getColor } from 'utils';

import styles from './GradientPanel.module.scss';

const GradientPanel = ({ className, isActive, isPrev, color }) => {
    color ??= 'orange';

    return (
        <div
            role="presentation"
            className={cx(styles.gradientPanel, className, {
                [styles.isActive]: isActive,
                [styles.isPrev]: isPrev,
            })}
            style={{
                '--slide-background-color': getColor(color),
            }}
        />
    );
};

GradientPanel.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    imageOnLeft: PropTypes.bool,
    isActive: PropTypes.bool,
    isPrev: PropTypes.bool,
};

export default GradientPanel;
